module.exports = __webpack_public_path__ + "static/media/parentGuardianBannerIcon.85ae905c.svg";